<template>
	<div class="activity">
		<van-list v-model="photosLoading" :finished="photosFinished" finished-text="暂无更多申请记录" @load="photosLoad">
			<div class="item_panel" v-for="(item, index) in photoList" :key="index" >
				<div class="titleBox" @click="handleDetail(item)">
					<div class="title">证书申领</div>
					<div class="status"
						:class="item.status == 0 ? 'oneStatus' : (item.status == 1 || item.status == 2) ? 'twoStatus' : ''">
						<!-- 状态 ，0-未支付，1-已支付，2-已邮寄，3-已取消，4-已退款 5-已完成-->
						{{ item.status == 0 ? "待支付" : "" }}

						<!-- // 0-待审核，1-同意，2-拒绝 3-取消申请 -->
						{{ item.status == 1 && item.refundStatus == -1 ? "已支付" : "" }}
						{{ item.status == 1 && item.refundStatus == 0 ? "退款审核中" : "" }}
						{{ item.status == 1 && item.refundStatus == 1 ? "已退款" : "" }}
						{{ item.status == 1 && item.refundStatus == 2 ? "退款失败" : "" }}
						{{ item.status == 1 && item.refundStatus == 3 ? "已支付" : "" }}

						{{ item.status == 2 ? "已邮寄" : "" }}
						{{ item.status == 3 ? "已取消" : "" }}
						{{ item.status == 4 ? "已退款" : "" }}
						{{ item.status == 5 ? "已完成" : "" }}


					</div>
				</div>
				<div class="content" @click="handleDetail(item)">
					<div class="imgContent" v-for="(subItem, subIndex) in item.certs" :key="subIndex">
						<img :src="subItem.certUrl" alt="">
						<div class="imgRight">
							<div class="imgTop">
								{{ subItem.typeName }}
							</div>
						</div>
					</div>
					<div class="fee">
						运费:<span>¥{{ item.amount }}</span>
					</div>
				</div>
				<div class="btns_index">
					<!-- 状态 ，0-未支付，1-已支付，2-已邮寄，3-已取消，4-已退款 5-已完成-->
					<div class="gray" v-if="item.status == 0 || item.status == 3 || item.status == 4" @click="handleDetail(item)">
						删除订单</div>
					<div class="action" v-if="item.status == 0" @click="handleDetail(item)">去支付</div>
			<!-- {{ item.status == 1 && item.refundStatus == -1 ? "已支付" : "" }}
						{{ item.status == 1 && item.refundStatus == 0 ? "退款审核中" : "" }}
						{{ item.status == 1 && item.refundStatus == 1 ? "已退款" : "" }}
						{{ item.status == 1 && item.refundStatus == 2 ? "退款失败" : "" }}
						{{ item.status == 1 && item.refundStatus == 3 ? "已支付" : "" }} -->
					<div class="gray" v-if="item.status == 1 && item.refundStatus == -1" @click="handleDetail(item)">申请退款</div>
					<div class="gray" v-if="item.status == 1 && item.refundStatus == 0" @click="handleDetail(item)">查看详情</div>
					<div class="gray" v-if="item.status == 1 && item.refundStatus == 1" @click="handleDetail(item)">查看详情</div>
					<div class="gray" v-if="item.status == 1 && item.refundStatus == 2" @click="handleDetail(item)">查看详情</div>
					<div class="gray" v-if="item.status == 1 && item.refundStatus == 3" @click="handleDetail(item)">申请退款</div>
			



					<div class="action" v-if="item.status == 2" @click="handleDetail(item)">确认收货</div>
					<div class="gray" v-if="item.status == 2" @click="handleDetail(item)">查看详情</div>
					<div class="gray" v-if="item.status == 3" @click="handleDetail(item)">查看详情</div>
					<div class="gray" v-if="item.status == 4" @click="handleDetail(item)">查看详情</div>
					<div class="gray" v-if="item.status == 5" @click="handleDetail(item)">查看详情</div>
				</div>
			</div>
		</van-list>

	</div>
</template>

<script>

import {
	certList
} from "@/utils/api/cert";
export default {
	components: {
		// Sign
	},
	watch: {

	},
	data() {
		return {
			workId: '',
			// 作品列表
			photoList: [],
			// loading
			photosLoading: false,
			// 是否全部加载
			photosFinished: false,
			// 作品页码
			photosPage: 0,
			// 每页条数
			photosPageSize: 10,


		};
	},
	mounted() {
		this.workId = this.$route.query.id
	},
	methods: {
		handleDetail(item) {
			this.$router.push({
				path: '/cert/detail',
				query: {
					id: item.id,
				}
			})
		},


		// 加载作品
		photosLoad() {
			this.photosPage++;
			this.getMyworksByPage(this.photosPage == 1);
		},


		getMyworksByPage(init = false) {

			if (init) this.photoList = [];
			this.photosLoading = true;
			certList({
				pageNo: this.photosPage,
				pageSize: this.photosPageSize
			}).then(res => {
				if (res.success) {
					const loadData = res.data.records
					loadData.forEach(element => {
						var certs = []
						if (element.certUrl) {
							var item = {
								certUrl: element.certUrl,
								typeName: '获奖证书',
							}
							certs.push(item)
						}
						if (element.practiceUrl) {
							var item = {
								certUrl: element.practiceUrl,
								typeName: '实践证书',
							}
							certs.push(item)
						}
						element.certs = certs;


						// 已支付状态:
						// 0-待审核，1-同意，2-拒绝 3-取消申请
						var refundStatus = -1
						var rejectReason = ''
						var refundId = ''
						if (element.status == 1) {
							var certOrderRefundTbl = element.certOrderRefundTbl || []
							if (certOrderRefundTbl.length > 0) {
								// 已经申请退款
								var refundItem = certOrderRefundTbl[0];
								refundId = refundItem.id
								refundStatus = refundItem.status
								rejectReason = refundItem.rejectReason || ''
							} else {
								// 没有申请退款
							}
						}
						element.refundStatus = refundStatus



					});

					this.photoList.push(...loadData);
				} else {
					this.photosLoading = false;
					this.photosFinished = true;
				}
				this.photosLoading = false;
				if (this.photosPage * this.photosPageSize > res.data.total) {
					this.photosFinished = true;
				}
			})
		},

	}
};
</script>
<style lang="scss" scoped>
.activity {
	width: 100%;
	max-width: 10rem;
	padding: 0 15px;
	overflow: hidden;
	background: #f8f8f9;
	min-height: 100vh;


	.applyBtn {

		background-color: #31D076;
		position: fixed;
		left: 15px;
		right: 15px;
		bottom: 15px;
		height: 40px;
		line-height: 40px;
		color: #fff;
		font-size: 16px;
		font-weight: bold;
		border-radius: 20px;


	}
}

.item_panel {
	margin: 15px 0px 0;
	border-radius: 10px;
	background-color: #fff;
	padding: 15px;

	.titleBox {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.title {
			color: #333;
			font-weight: bold;
			font-size: 18px;
		}

		.status {
			height: 20px;
			line-height: 20px;
			padding: 0 10px;
			font-size: 12px;
			border-radius: 10px;
			border: 1px solid #C9C9C9;
			color: #666;
		}

		.twoStatus {
			border: none;
			color: rgba(49, 208, 118, 1);
			background-color: rgba(49, 208, 118, 0.10);
		}

		.oneStatus {
			border: none;
			color: rgba(255, 114, 70, 1);
			background-color: rgba(255, 114, 70, .1);
		}
	}

	.content {
		margin-top: 10px;

		.imgContent {
			display: flex;
			text-align: left;
			margin-bottom: 15px;

			img {
				width: 100px;
				height: 70px;
				border-radius: 10px;
			}

			.imgRight {
				margin-left: 10px;
				flex: 1;

				.imgTop {
					font-weight: bold;
					color: #333;

				}

				.imgBottom {
					margin-top: 10px;
					color: #666;
				}
			}
		}

		.fee {
			padding-bottom: 15px;
			text-align: right;
			color: #666;

			span {
				font-weight: bold;
				color: #333;
			}
		}
	}

	.btns_index {
		border-top: 1px solid #eee;
		padding-top: 15px;
		display: flex;
		justify-content: flex-end;

		.action {
			margin-left: 15px;
			height: 30px;
			line-height: 30px;
			background-color: #31D076;
			color: #fff;
			border-radius: 15px;
			padding: 0 10px;
		}

		.gray {
			margin-left: 15px;
			height: 30px;
			line-height: 30px;
			border: 1px solid #C9C9C9;
			color: #666;
			border-radius: 15px;
			padding: 0 10px;
		}
	}
}
</style>
